module.exports = __webpack_public_path__ + "img/dishub-icon.174d0a45.png";